import React, { useState } from 'react';
import { useZxing } from 'react-zxing';

const Scanner = ({ onScanSuccess, onScanError }) => {
  const [scannedValue, setScannedValue] = useState(null); // Lagrer skannet EAN-verdi
  const [error, setError] = useState(null); // Lagre skannerfeil

  const { ref } = useZxing({
    onResult: (result) => {
      if (result) {
        const value = result.getText(); // Få den tekstlige verdien fra QR- eller strekkoden
        setScannedValue(value); // Sett verdien lokalt for visning
        onScanSuccess(value); // Pass verdien tilbake til foreldren (App.js)
      }
    },
    onError: (error) => {
      console.error("Scanner-feil:", error);
      setError("Kunne ikke lese kode. Vennligst prøv igjen."); // Forbedret feilmelding
      onScanError(error); // Send feilen opp til forelderen
    },
    constraints: {
      video: {
        facingMode: 'environment', // Bruker bak-kameraet
      },
    },
    formats: ['ean_13', 'ean_8', 'upc_e', 'qr_code'], // Spesifiser tillatte formater
    timeBetweenDecodingAttempts: 500, // Kontroll mellom skanningsforsøk
  });

  const resetScanner = () => {
    setScannedValue(null); // Nullstill siste verdi
    setError(null); // Tøm feilmelding
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <video
        ref={ref}
        style={{
          width: '100%',
          maxWidth: '200px',
          border: '1px solid grey',
          marginBottom: '10px',
        }}
      />
      <p>Rett kameraet mot en varekode</p>

      {/* Vise den skannede varekoden */}
      {scannedValue && (
        <div>
          <p>
            <strong>EAN funnet:</strong> {scannedValue}
          </p>
          <button onClick={resetScanner} style={{ marginTop: '10px' }}>
            Skann på nytt
          </button>
        </div>
      )}

      {/* Vise feil dersom noe går galt */}
      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          <p><strong>Feil:</strong> {error}</p>
          <button onClick={resetScanner} style={{ marginTop: '10px' }}>
            Prøv igjen
          </button>
        </div>
      )}
    </div>
  );
};

export default Scanner;